module.exports = function() {
  return new Worker(__webpack_public_path__ + "b75bde4d3e0bc09438a5.worker.js");
};